var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"96vw","height":"96vw","display":"none"},attrs:{"id":"widthdemo"}}),_c('div',{ref:"qrcodeprivateuse",staticStyle:{"width":"10vw","height":"10vw"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }